const messages = {
  de: {
    post: {
      title_create: 'Beitrag erstellen',
      title_edit: 'Beitrag bearbeiten',
      label: {
        teaser_image: 'Beitragsbild',
        status: 'Status',
        type: 'Beitragstyp',
      },
      types: {
        diy: 'Do-it-yourself',
        single: 'Einzel',
      },
      status: {
        draft: 'Entwurf',
        published: 'Veröffentlicht',
      },
    },
  },
};

export default messages;
